// @ts-strict-ignore
import {Component, computed, inject, input, Input, TemplateRef, output} from "@angular/core";
import {AssessableItem, ChecklistItemType, ScenarioRecording} from "@models";
import {Translations} from "@translations";
import {SimConfigurationService, SimUtilityService, TrackByMethods} from "@services";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {UntilDestroy} from "@ngneat/until-destroy";
import {AssessableContextService} from "../services/assessment-context.service";
import {AssessablePanelMode} from "@common/components/assessment/utils";

@UntilDestroy()
@Component({
	selector: "sim-assessable-item",
	templateUrl: "./assessable-item.component.html",
	styleUrls: ["./assessable-item.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 250}), zoomOutOnLeaveAnimation({duration: 250})],
	standalone: false,
})
export class AssessableItemComponent {
	// Enums
	protected readonly AssessablePanelMode = AssessablePanelMode;
	protected readonly ChecklistItemType = ChecklistItemType;
	protected readonly T = Translations;
	protected readonly TrackByMethods = TrackByMethods;
	protected readonly SimConfigurationService = SimConfigurationService;
	protected readonly SimUtilityService = SimUtilityService;

	// Inputs
	public readonly indexInGroup = input<number>(0);
	public readonly groupIndex = input<number | null>(null);

	@Input({required: true}) scenarioRecording: ScenarioRecording | null;

	@Input({required: true}) item: AssessableItem;
	@Input({required: true}) mode: AssessablePanelMode;
	@Input({required: true}) inEditMode: boolean;
	@Input({required: true}) expanded: boolean;
	@Input({required: true}) canEnterEditMode: boolean;
	@Input() isInArchive = false;
	@Input() hideExpandButton = false;
	@Input() disabled = false;

	@Input() scoreTemplate: TemplateRef<void>;
	@Input() dragHandleTemplate: TemplateRef<void>;
	@Input() answerBadgeTemplate: TemplateRef<void>;
	@Input() menuContentTemplate: TemplateRef<void>;
	@Input() yesNoItemTemplate: TemplateRef<void>;
	@Input() ratingItemTemplate: TemplateRef<void>;
	@Input() freeAnswerItemTemplate: TemplateRef<void>;
	@Input() multipleChoiceItemTemplate: TemplateRef<void>;
	@Input() singleChoiceItemTemplate: TemplateRef<void>;
	@Input() middleAdditionalContentTemplate: TemplateRef<void>;

	// Outputs
	onChangeChecklistItemType = output<ChecklistItemType>();
	onTimestampClicked = output<void>();
	onExpand = output<void>();
	onCollapse = output<void>();

	public readonly indexOne = computed<number>(() =>
		this.groupIndex() !== null ? this.groupIndex() + 1 : this.contextService.form.value.assessableGroups.length + 1,
	);
	public readonly indexTwo = computed<number>(() => this.indexInGroup() + 1);

	public tooltipDisabled = false;

	public contextService: AssessableContextService<AssessableItem> = inject(AssessableContextService<AssessableItem>);

	public get itemControl() {
		return this.contextService.findItemControl(this.item.assessableItemId);
	}

	public handleItemTypeChange(type: ChecklistItemType) {
		this.contextService.handleItemTypeChange(this.item, type);
	}

	public togglePanel() {
		if (this.expanded) {
			this.onCollapse.emit();
		} else {
			this.onExpand.emit();
		}
	}
}
